export {
  DEFAULT_PICKUP_CAPACITY,
  InputPickupCapacity,
} from './InputPickupCapacity';
